import React from 'react'
import { WholesalerContextShape } from '../wholesaler-integration/WholesalerContext'
import { BomItem } from '../bom/bomUtils'
import { BuildConfig } from '../config/BuildConfig'
import { WholesalerListSection } from './WholesalerListSection'
import ButtonsPopup from '../components/ButtonsPopup'
import SpinnerPopup from '../components/SpinnerPopup'
import Popup from '../components/Popup'
import Button from '../components/Button'
import { IconCrossGrey } from '../components/icons'
import { ProductPriceAvailable, ProductPriceUnavailable } from '../productPricing/ProductPricingContext'
import { WarningPopupGraphic } from '../components/WarningPopupGraphic'

type WholesalerPopupType = {
  type: 'success'
  itemsSucceeded: string[]
  itemsFailed: string[]
} | {
  type: 'error'
} | {
  type: 'confirmation'
} | {
  type: 'adding to cart'
}
export const WholesalerListWorkflow: React.FC<{
  wholesalerContext: WholesalerContextShape
  onClickDownloadList: () => void
  fullListBom: BomItem[]
  totalPrice: ProductPriceAvailable | typeof ProductPriceUnavailable
}> = ({
  wholesalerContext,
  onClickDownloadList,
  fullListBom,
  totalPrice,
}) => {
  const [wholesalerPopup, setWholesalerPopup] = React.useState<WholesalerPopupType | null>(null)

  const onClickAddToWholesalerCart = () => {
    if (fullListBom.length > 0) {
      setWholesalerPopup({ type: 'adding to cart' })

      wholesalerContext.addToWholesalerCart(
        fullListBom.map(
          bomItem => ({
            itemNo: bomItem.itemNo,
            quantity: bomItem.quantity,
          }),
        ),
      )
        .then(response => {
          const succeeded = response.items.filter(item => item.success).map(item => item.itemNo)
          const failed = response.items.filter(item => !item.success).map(item => item.itemNo)
          setWholesalerPopup({ type: 'success', itemsSucceeded: succeeded, itemsFailed: failed })
        })
        .catch(e => {
          console.error('error adding to cart', e)
          setWholesalerPopup({ type: 'error' })
        })
    }
  }

  const copy = BuildConfig.brand.copy.Wholesaler

  return (
    <>
      <div style={{ position: 'sticky', bottom: 0 }}>
        <WholesalerListSection
          {...{ wholesalerContext }}
          onClickAddToCart={() => setWholesalerPopup({ type: 'confirmation' })}
        />
      </div>

      {wholesalerPopup?.type === 'success' && (
        <ButtonsPopup
          orientation="row"
          actions={[{
            label: copy.AddToCartSuccessPopup.CartButton,
            onClick: () => {
              setWholesalerPopup(null)
              wholesalerContext?.goToWholesalerCart()
            },
            style: 'green',
          }]}
          title={copy.AddToCartSuccessPopup.Title}
        >
          {copy.AddToCartSuccessPopup.Body}
          {/*{wholesalerPopup.itemsSucceeded} {wholesalerPopup.itemsSucceeded === 1 ? 'product was added' : 'products were added.'}*/}
          {
            wholesalerPopup.itemsFailed.length > 0 && (
              <>
                <div style={{ marginTop: '20px' }}>
                  {wholesalerPopup.itemsFailed.length === 1 ? 'This item' : 'These items'} couldn&apos;t be added:
                  <ul style={{ textAlign: 'left' }}>
                    {
                      wholesalerPopup.itemsFailed.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))
                    }
                  </ul>
                </div>
              </>
            )
          }
        </ButtonsPopup>
      )}

      {(wholesalerPopup?.type === 'confirmation' && onClickAddToWholesalerCart) && (
        <ButtonsPopup
          actions={[
            {
              style: 'default',
              label: copy.AddToCartPopup.CancelButton,
              onClick: () => setWholesalerPopup(null),
            },
            {
              style: 'green',
              label: copy.AddToCartPopup.ConfirmButton,
              onClick: onClickAddToWholesalerCart,
            },
          ]}
          orientation="row"
          title={copy.AddToCartPopup.Title}
        >
          {copy.AddToCartPopup.Body}
        </ButtonsPopup>
      )}

      {wholesalerPopup?.type === 'adding to cart' && (
        <SpinnerPopup>
          {copy.AddToCartLoading}
        </SpinnerPopup>
      )}

      {wholesalerPopup?.type === 'error' && (
        <Popup
          onClose={() => {
            return
          }}
        >
          <Button
            round
            flat
            buttonStyle="white"
            onClick={() => setWholesalerPopup(null)}
            style={{ position: 'absolute', top: 0, right: 0 }}
          >
            <img src={IconCrossGrey} alt="close"/>
          </Button>
          <WarningPopupGraphic />
          <div className="title">
            {copy.AddToCartFailedPopup.Title}
          </div>
          <div style={{ textAlign: 'center' }}>
            {copy.AddToCartFailedPopup.Body}
            <br/>
            <Button
              style={{
                minWidth: '80%',
                margin: '20px 0',
              }}
              buttonStyle="green"
              onClick={() => {
                onClickAddToWholesalerCart?.()
              }}
            >
              {copy.AddToCartFailedPopup.TryAgainButton}
            </Button>
            <div style={{ fontSize: '0.8em' }}>
              {'or '}
              <Button
                buttonStyle="inlineLink"
                onClick={() => {
                  onClickDownloadList()
                  setWholesalerPopup(null)
                }}
              >
                Download
              </Button> your list and contact your wholesaler
            </div>
          </div>
        </Popup>
      )}
    </>
  )

}